import { render } from "./ProductSectionComponent.vue?vue&type=template&id=45e87ef9"
import script from "./ProductSectionComponent.vue?vue&type=script&lang=js"
export * from "./ProductSectionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/home/ProductSectionComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45e87ef9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45e87ef9', __exports__)) {
    api.reload('45e87ef9', __exports__)
  }
  
  module.hot.accept("./ProductSectionComponent.vue?vue&type=template&id=45e87ef9", () => {
    api.rerender('45e87ef9', render)
  })

}


export default __exports__